<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <div class="wrapper">
    <canvas id="canvas" :style="{ height: 'auto', width: '100%' }" type="2d" />
    <!-- <input id="exp1" class="exp" type="checkbox" />
    <div class="text">
      <label class="btn" for="exp1"></label>
      方形。其中有两个向左浮动，一个向右浮动。要注意到第二个向左浮动的正方形被放在第一个向左浮动的正方形的右边。如果还有更多的正方形这样浮动，它们会继续向右堆放，直到填满容器一整行，之后换行至下一行大是大非水电费水电费水电费水电费是的冯绍峰。
    </div> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      circlePointX: 0,
      circlePointY: 0,
      circleRadius: 0,
      dpr: 1,
    };
  },
  mounted() {
    this.draw();
  },
  methods: {
    draw() {
      const canvas = document.querySelector("#canvas");
      this.dpr = window.devicePixelRatio;

      const canvasH = canvas.getBoundingClientRect().height;
      const canvasW = canvas.getBoundingClientRect().width;
      const levelNum = 3; // 等级数量
      const unit = 180 / (levelNum - 1); // 获取单等级的角度
      canvas.width = canvasW * this.dpr;
      canvas.height = canvasH * this.dpr;
      const ctx = canvas.getContext("2d");
      this.circlePointX = canvas.width / 2;
      this.circlePointY = canvas.height - 60 * this.dpr;
      this.circleRadius = 136 * this.dpr;

      console.log("canvas", canvas.width, canvas.height, this.circleRadius);

      this.drawOut(ctx);
      this.drawLv(ctx, unit);
      ctx.save();
    },
    drawOut(ctx) {
      ctx.beginPath();
      ctx.arc(
        this.circlePointX,
        this.circlePointY,
        this.circleRadius,
        0,
        Math.PI,
        true
      );
      ctx.strokeStyle = "#393C45";
      ctx.lineWidth = 13;
      ctx.stroke();
    },
    drawLv(ctx, unit) {
      ctx.beginPath();
      // ctx.fillStyle = "#393C45";
      ctx.strokeStyle = "#FF9A64";
      ctx.arc(
        this.circlePointX,
        this.circlePointY,
        this.circleRadius,
        Math.PI,
        Math.PI + (unit * (2 - 1) * Math.PI) / 180,
        0
      );
      ctx.stroke();
    },
  },
  // data() {
  //   return {
  //     text: "Some very very long text contentome vry long text contentome very ry long text contentome very ery very long text contentome very very long text contentome very very long text content.",
  //   };
  // },
};
</script>
<style lang="less">
.wrapper {
  display: flex;
  margin: 50px auto;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 20px 20px 60px #bebebe, -20px -20px 60px #ffffff;
}
.text {
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  /* display: flex; */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  position: relative;
}
.text::before {
  content: "";
  height: calc(100% - 24px);
  float: right;
}
.text::after {
  content: "";
  width: 999vw;
  height: 999vw;
  position: absolute;
  box-shadow: inset calc(100px - 999vw) calc(30px - 999vw) 0 0 #fff;
  margin-left: -100px;
}
.btn {
  float: right;
  clear: both;
  margin-left: 10px;
  font-size: 16px;
  padding: 0 8px;
  background: #3f51b5;
  line-height: 24px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  /* margin-top: -30px; */
}
.btn::before {
  content: "展开";
}
.exp {
  display: none;
}
.exp:checked + .text {
  -webkit-line-clamp: 999;
}
.exp:checked + .text::after {
  visibility: hidden;
}
.exp:checked + .text .btn::before {
  content: "收起";
}
</style>